// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2373) return "static/chunks/2373.76d220db86567cd2.js";
	if (chunkId === 8837) return "static/chunks/8837.e49b67e9a756c34f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"798":"66d1a3d77b6f60da","1126":"bdce6b8af5374b49","1806":"47e66f99b64921ae","1969":"7da69a07925605e4","5758":"e33ffcc460beea22"}[chunkId] + ".js";
};